import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

export default class FormInputSelect extends Component {

	constructor(props) {
		super(props);
		this.state = {
			defaultValue: this.props.defaultValue
		}
		if (props.callbackValue) props.callbackValue(this.state.defaultValue)
	}

	handleChange = event => {
		this.setState({ defaultValue: event.target.value });
		if (this.props.callbackValue) this.props.callbackValue(event.target.value)
	}

	render() {
		const classes = makeStyles(theme => ({ formControl: { "& .MuiPaper-root": { maxHeight: '340px' } } }));
		const { id, labelId, label, labelText, optionsSelect, /* classNameCustom,  */name } = this.props;
		let optionCode
		const Residencia = name.indexOf("country");
		const Nacionalidad = name.indexOf("nationality");
		const adultos = name.indexOf("adultos");
		const jovenes = name.indexOf("jovenes");
		const menores = name.indexOf("menores");

		return (
			<FormControl variant="outlined" fullWidth className={`InputForm ${classes.formControl}`} >
				<InputLabel id={`label-${id}`}>{label}</InputLabel>
				<Select
					//className={`InputForm ${classNameCustom}`}
					labelId={labelId}
					id={id}
					name={name}
					onChange={this.handleChange}
					label={labelText}
					value={this.state.defaultValue}
				//className={classNameCustom}
				>
					{/* logica buscador trenes */}
					{(adultos === 0 || jovenes === 0 || menores === 0) && optionsSelect[this.state.defaultValue] === undefined &&
						optionsSelect.push({ code: this.state.defaultValue, description: this.state.defaultValue })
					}

					{optionsSelect.map((option, i) => (
						Nacionalidad === 0 || Residencia === 0 ?
							optionCode = option.code_2
							: optionCode = option.code,
						<MenuItem key={i} value={optionCode}>{option.description}</MenuItem>
					))}
				</Select>
			</FormControl>
		)
	}
}
